import { useContent } from 'src/contexts/ContentContext';
import { PosDropdown } from 'src/core/POS/PosDropdown';
import { vars } from 'src/core/themes';
import { IconsFill, MoreIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { ExportPaymentAction } from './ExportPaymentAction';

export const GroupedPaymentsAccordionActionDropdown = ({
  firstOfMonth,
}: {
  firstOfMonth: string;
}) => {
  const actionsMsg = useContent(ContentId.Actions);
  return (
    <>
      <PosDropdown
        key="payments-action-dropdown"
        trigger={
          <div
            title={actionsMsg}
            style={{ padding: `0 ${vars.spacing.sm} 0 ${vars.spacing.xxs}` }}
          >
            <MoreIcon
              withHoverEffect
              fill={IconsFill.textBrand}
              align="middle"
            />
          </div>
        }
        align="end"
      >
        <ExportPaymentAction firstOfMonth={firstOfMonth} />
      </PosDropdown>
    </>
  );
};
